import React, { useCallback, useContext, useState } from 'react';
import { Button, Input, Modal } from 'antd';

import ModalFooter from '@totem/components/ui_components/dialogs/ModalFooter';
import ModalTitle from '@totem/components/ui_components/dialogs/ModalTitle';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import VendorContext from '@totem/components/vendors/VendorContext';
import colors from '@totem/styles/colors';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';
import { CheckResponseShowError } from '@totem/utilities/responseUtilities';
const styles = {
  dialog: {
    maxHeight: '80%',
    maxWidth: '850px',
  },
  label: {
    fontSize: '12px',
    fontWeight: 600,
  },
};
type Props = {
  open: boolean;
  onClose: () => void;
  vendorName: string;
};
const VendorEditDialog = ({ open, onClose, vendorName }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [isSending, setIsSending] = useState(false);
  const [name, setName] = useState<string>(vendorName);
  const { onAction } = useContext(VendorContext);
  const sendMergeRequest = useCallback(
    async (payload: any) => {
      if (isSending) {
        return;
      }
      setIsSending(true);

      fetch(`${DEVICES_ENDPOINT}/vendors/rename`, {
        method: 'POST',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
        body: JSON.stringify(payload),
      }).then((res) => {
        CheckResponseShowError(res);

        setIsSending(false);

        onAction('refresh', null);

        onClose();
      });
    },
    [getApiToken],
  );
  const handleSubmit = () => {
    const payload = {
      originalName: vendorName,
      newName: name,
    };
    sendMergeRequest(payload);
  };
  return (
    <Modal
      open={open}
      onCancel={() => onClose()}
      title={<ModalTitle>Vendor Edit</ModalTitle>}
      confirmLoading={false}
      style={styles.dialog}
      footer={
        <ModalFooter>
          <Button onClick={() => onClose()}>Close</Button>
          <Button onClick={handleSubmit} type="primary" disabled={isSending}>
            Submit
          </Button>
        </ModalFooter>
      }
    >
      <div style={styles.label}>
        Name: <span style={{ color: colors.utility.error }}>*</span>
      </div>
      <div>
        <Input value={name} onChange={(val) => setName(val.target.value)} />
      </div>
      <br />
    </Modal>
  );
};
export default VendorEditDialog;
